// App shell: error boundary > data cache provider > session provider > MUI
// theme > router > the WALL > the screens. (Replaces the Iteration-1 walking
// skeleton, per the navigation/README contract.) The session provider sits
// under the data provider because logout resets the cache; the gate sits
// inside the router so the PIN screen holds the URL the reader asked for.
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";

import AuthGate from "components/AuthGate";
import ErrorBoundary from "components/ErrorBoundary";
import { AppDataProvider } from "contexts/AppDataContext";
import { SessionProvider } from "contexts/SessionContext";
import RouterConfig from "navigation/RouterConfig";
import muiTheme from "styles/muiTheme";

// Scroll is owned by the app, not the browser: every forward navigation opens
// at the top (navigation/RouterConfig's ScrollToTop, a layout effect on the
// location), the Leaderboard and the stats page restore their own remembered
// offsets on the way back via AppDataContext. With the default 'auto', the
// browser re-applies a history entry's old offset AFTER those effects on
// back/forward and reload, so a brand page could open mid-page.
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

function App() {
  return (
    <ErrorBoundary>
      <AppDataProvider>
        <SessionProvider>
          <ThemeProvider theme={muiTheme}>
            <BrowserRouter>
              <AuthGate>
                <RouterConfig />
              </AuthGate>
            </BrowserRouter>
          </ThemeProvider>
        </SessionProvider>
      </AppDataProvider>
    </ErrorBoundary>
  );
}

export default App;
